<template>
  <v-card
    v-if="url"
    @click="$emit('select')"
    class="d-flex flex-column overflow-hidden card-file"
    :class="{ cover: !!cover }"
    height="100%"
  >
    <div class="position-relative card-file-overlay">
      <template v-if="fileExtension === 'pdf'">
        <PdfPreviewWidget :id="file" :url="url" />
      </template>

      <template
        v-else-if="['jpg', 'jpeg', 'png', 'webp'].includes(fileExtension)"
      >
        <img class="d-block responsive" :src="url" />
      </template>

      <template v-else-if="fileExtension === 'mp4'">
        <video
          class="d-block responsive"
          preload="metadata"
          crossorigin="anonymous"
          webkit-playsinline
          playsinline
          controls
        >
          <source :src="url" type="video/mp4" />
          Seu navegador não suporta vídeo HTML5.
        </video>
      </template>

      <template
        v-if="
          ['doc', 'docx', 'xls', 'xslx', 'ppt', 'pptx'].includes(fileExtension)
        "
      >
        <div class="d-flex align-center justify-center responsive">
          <v-icon size="56"> mdi-file-document-outline </v-icon>
        </div>
      </template>

      <template v-else-if="isVideoYoutube">
        <iframe
          class="d-block responsive"
          :src="url"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </template>

      <v-icon
        class="card-file-checkbox d-block"
        :color="checked ? 'black' : 'rgba(255, 255, 255, .8)'"
        size="22"
      >
        {{ checkbox }}
      </v-icon>

      <div class="card-file-menu">
        <v-menu
          content-class="rounded-lg mt-2 menu-dropdown"
          min-width="120px"
          offset-y
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="rounded-lg"
              color="rgba(255, 255, 255, .8)"
              height="28px"
              width="28px"
              depressed
              x-small
              fab
            >
              <v-icon color="secondary">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list class="pa-1">
            <!-- alterar href para gallery quando for imagem -->
            <v-list-item
              class="rounded-lg overflow-hidden px-3"
              :href="url"
              target="_blank"
              dense
            >
              <v-list-item-title> Visualizar </v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="isImage"
              @click="$emit('highlight')"
              class="rounded-lg overflow-hidden px-3"
              dense
            >
              <v-list-item-title>
                {{ cover ? "Remover destaque" : "Destacar" }}
              </v-list-item-title>
            </v-list-item>

            <!-- <v-list-item
              @click="editar(doc)"
              class="rounded-lg overflow-hidden px-3"
              dense
            >
              <v-list-item-title> Editar </v-list-item-title>
            </v-list-item> -->

            <div class="mx-n1">
              <v-divider class="my-1" />
            </div>

            <v-list-item
              @click="$emit('delete')"
              class="error--text rounded-lg overflow-hidden px-3"
              dense
            >
              <v-list-item-title> Excluir </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <template v-if="cover">
        <v-sheet
          class="d-flex align-center rounded-lg cover-icon"
          color="rgba(255, 185, 0, 1)"
        >
          <v-icon size="14" color="black"> mdi-star </v-icon>
          <div class="black--text text-caption font-weight-medium ml-1">
            Destaque
          </div>
        </v-sheet>
      </template>
    </div>

    <v-divider />

    <v-sheet
      class="d-flex flex-column justify-center pa-2"
      color="transparent"
      height="100%"
    >
      <div
        v-if="name"
        class="black--text text-caption text-sm-body-2 text-center font-weight-medium card-file-name"
      >
        {{ name }}
      </div>

      <div
        class="secondary--text text--lighten-2 text-caption text-center font-weight-regular"
        :class="{ 'mt-1': name }"
      >
        {{ formatDate(created_at) }}
      </div>
    </v-sheet>
  </v-card>
</template>

<script>
import PdfPreviewWidget from "@/components/widgets/PdfPreview.vue";
import formatDate from "@/utils/formatDate";

export default {
  components: { PdfPreviewWidget },
  props: {
    id: Number,
    name: {
      type: String,
      defailt: "",
    },
    url: String,
    file: {
      type: String,
      defailt: "",
    },
    created_at: String,
    isImage: {
      type: Boolean,
      defailt: false,
    },
    isVideoYoutube: {
      type: Boolean,
      defailt: false,
    },
    cover: {
      type: Number,
      defailt: 0,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkbox() {
      return this.checked ? "mdi-checkbox-marked" : "mdi-checkbox-blank";
    },
    fileExtension() {
      if (!this.file) return null;
      return this.file.split(".").pop().toLowerCase();
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    formatDate,
  },
};
</script>

<style lang="scss" scoped>
.card-file {
  background-color: #ffffff;
  border: 1px solid #ddd6d2 !important;
  border-radius: 12px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0 0 0 / 0.1) !important;
  // cursor: move;
  transition: all 0.1s linear;

  @media screen and (max-width: 599.9px) {
    border-radius: 8px !important;
    padding: 12px;
  }

  &-overlay {
    &:before {
      background: linear-gradient(
        185deg,
        rgba(1, 1, 1, 0.5),
        rgba(255, 255, 255, 0) 50%
      );
      bottom: 0;
      content: "";
      left: 0;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;
      transition: all 0.1s linear;
    }
  }

  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -4px rgba(0, 0, 0, 0.1) !important;

    .card-file-overlay {
      &:before {
        opacity: 1;
      }
    }
  }

  &-checkbox {
    left: 8px;
    position: absolute;
    top: 8px;
    text-stroke: 1px #fff;
    -webkit-text-stroke: 1px #fff;

    &.mdi-checkbox-marked {
      text-stroke: initial;
      -webkit-text-stroke: initial;
    }
  }

  &-menu {
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 1;

    .v-btn {
      backdrop-filter: blur(8px);
    }
  }

  &-name {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

.responsive {
  aspect-ratio: 16 / 9;
  height: auto !important;
  object-fit: cover;
  object-position: top;
  width: 100%;
}

.cover {
  box-shadow: 0 0 0 1px rgba(255, 185, 0, 0.3) !important;
  border: 1px solid #ffb900 !important;

  &:after {
    background-color: #ffb900;
    border-radius: 0 0 0 5px;
    content: "";
    height: 30px;
    opacity: 1;
    position: absolute;
    right: 0;
    top: 0;
    width: 30px;
  }
}

.cover-icon {
  bottom: 8px;
  left: 8px;
  padding: 1px 4px;
  position: absolute;
}
</style>
